import { DailyPlanStateTypes, DailyPlanActionTypes } from "./DailyPlan.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: DailyPlanStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const DailyPlanReducer = (
  state: DailyPlanStateTypes = INITIAL_STATE,
  action: any
): DailyPlanStateTypes => {
  switch (action.type) {
    case DailyPlanActionTypes.FETCH_ALL_DAILY_PLAN:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case DailyPlanActionTypes.FETCH_ALL_DAILY_PLAN_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case DailyPlanActionTypes.FETCH_ALL_DAILY_PLAN_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case DailyPlanActionTypes.FETCH_ALL_DAILY_PLAN_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case DailyPlanActionTypes.FETCH_ONE_DAILY_PLAN:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case DailyPlanActionTypes.FETCH_ONE_DAILY_PLAN_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case DailyPlanActionTypes.FETCH_ONE_DAILY_PLAN_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case DailyPlanActionTypes.FETCH_ONE_DAILY_PLAN_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default DailyPlanReducer;
